import { Outlet, useLocation } from 'react-router-dom';

import Banner from '@/components/Banner';
import { Layout } from '@/components/Layout';

const DashboardLayout = () => {
  const location = useLocation();

  // Define which pages are "live" vs "demo"
  const livePages = [
    '/dashboard',
    '/groups',
    '/inbox',
    '/contacts',
    '/media',
    '/tags',
    '/management',
    '/settings',
    '/tickets',
  ];

  // Check exact match or starts with (for dynamic routes like /tags/:id)
  const isLivePage =
    livePages.includes(location.pathname) ||
    livePages.some((page) => location.pathname.startsWith(`${page}/`));

  return (
    <Layout>
      <div className="flex h-full flex-col overflow-hidden">
        <Banner status={isLivePage ? 'live' : 'demo'} />
        <div className="h-[100vh-40px] min-h-0 flex-1 overflow-hidden">
          <Outlet />
        </div>
      </div>
    </Layout>
  );
};

export default DashboardLayout;
